document.addEventListener("DOMContentLoaded", () => {
  /**
   *  Toggler menu *
   **/
  document.querySelector(".close").addEventListener("click", () => {
    document.querySelector("#menu").style.display = "none";
    document.querySelector(".toggler").style.display = "flex";
  });
  document.querySelector(".toggler").addEventListener("click", () => {
    document.querySelector("#menu").style.display = "flex";
    document.querySelector(".toggler").style.display = "none";
  });


  /**
   * Menu espace mon compte
   */
  let menu_compte = document.querySelector(".moncompte-titre");
  if(menu_compte) {
    menu_compte.addEventListener("click", () => {
      document.querySelector(".woocommerce-MyAccount-navigation").classList.toggle('visible');
    });
  }


  /**
   *  Fixed menu *
   **/
  function fixedMenu() {
    let navbar = document.querySelector("header");
    if (navbar) {
      navbar.classList.toggle("scrolled", window.scrollY >= 50);
    }

    let barreCodePromo = document.getElementById('modalCodePromo');
    if (barreCodePromo) {
      barreCodePromo.classList.toggle("scrolled", window.scrollY >= 50);
    }
  }

  document.addEventListener("scroll", () => {
    requestAnimationFrame(fixedMenu);
  });

  let barreCodePromo = document.getElementById('modalCodePromo');
  if (barreCodePromo) {
    startCountdown();
  }


  /**
   * ACOORDEON *
   **/
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }


  /**
   * PARALLLAX *
   */
  if (window.matchMedia && window.matchMedia('screen and (min-width: 992px)').matches) {
    /*=============================================>>>>>
        = Parallax à la souris =
        ===============================================>>>>>*/
    document.addEventListener("mousemove", parallax);

    function parallax(e) {
      document.querySelectorAll(".parallax").forEach(function (move) {
        let moving_value = move.getAttribute("data-value");
        let x = (e.clientX * moving_value) / 250;
        let y = (e.clientY * moving_value) / 250;
        move.style.transform = "translateX(" + x + "px) translateY(" + y + "px)";
      });
    }

    document.addEventListener("mousemove", parallaxX);

    function parallaxX(e) {
      document.querySelectorAll(".parallaxX").forEach(function (moveX) {
        let moving_value = moveX.getAttribute("data-value");
        let x = (e.clientX * moving_value) / 250;
        moveX.style.transform = "translateX(" + x + "px)";
      });
    }

    const counters = document.querySelectorAll(".value");
    const speed = 50000;
    counters.forEach((counter) => {
      const animate = () => {
        const value = +counter.getAttribute("data-compte");
        const data = +counter.innerText;
        const time = value / speed;
        if (data < value) {
          counter.innerText = Math.ceil(data + time);
          setTimeout(animate, 2);
        } else {
          counter.innerText = value;
        }
      };
      document.addEventListener("aos:in", ({counter}) => {
        animate();
      });

    });
  }


  /**
   * MODAL *
   **/
  function afficherModal(modal) {
    modal.style.display = "block";
  }

  function fermerModal(modal) {
    modal.style.display = "none";
  }

  function handleModalClick(targetHref, modal, annulerBtn, ajouterBtn, continuerBtn, closeModalBtn) {
    if (annulerBtn) {
      annulerBtn.addEventListener("click", function () {
        fermerModal(modal);
      });
    }

    if (ajouterBtn) {
      ajouterBtn.addEventListener("click", function () {
        window.location.href = targetHref;
      });
    }

    if (closeModalBtn) {
      closeModalBtn.addEventListener("click", function () {
        fermerModal(modal);
      });
    }
  }

  function handleOutsideModalClick(modal) {
    window.addEventListener("click", function (event) {
      if (event.target === modal) {
        fermerModal(modal);
      }
    });
  }

  function initializeModal(modalId, elements, modalType) {
    if (elements) {
      elements.forEach(function (element) {
        let modal = document.getElementById(modalId);
        let targetHref = element.getAttribute("href");
        let annulerBtn = modal.querySelector(".annulerBtn");
        let continuerBtn = modal.querySelector(".continuerBtn");
        let ajouterBtn = modal.querySelector(".ajouterBtn");
        let closeModalBtn = modal.querySelector(".close");
        element.addEventListener("click", function (event) {
          event.preventDefault();
          if (modal) {
            afficherModal(modal);
            handleModalClick(targetHref, modal, annulerBtn, ajouterBtn, continuerBtn, closeModalBtn);
            handleOutsideModalClick(modal);
          }
        });
      });
    }
  }

  if( document.getElementById('modalListeCoach')) {
    initializeModal("modalListeCoach", document.querySelectorAll(".afficher-modal-liste-coach"));
  }
  if( document.getElementById('modalPack')) {
    initializeModal("modalPack", document.querySelectorAll(".afficher-modal-pack"));
  }
  if( document.getElementById('modalCoach')) {
    initializeModal("modalCoach", document.querySelectorAll(".afficher-modal-coach"));
  }

  /**
   * Modal Code Promo
   */
  if( document.getElementById('modalCodePromo')) {
    let modal = document.getElementById('modalCodePromo');
    let closeModalBtn = modal.querySelector(".btn-close");
    modal.style.display = "flex";
    closeModalBtn.addEventListener("click", function () {
      fermerModal(modal);
    });
  }


  /**
   * SOUS MENU *
   **/
  document.querySelector(".close").addEventListener("click", () => {
    document.querySelector("#menu").style.display = "none";
    document.querySelector(".toggler").style.display = "flex";
  });


  /**
   *  TEAMCARDS *
   **/
  let teamCards = document.querySelectorAll(".team-card");
  teamCards.forEach((card) => {
    card.addEventListener("click", () => {
      card.classList.toggle("expand");
    });
  });


  /**
   * VIDEO E-LEARNING *
   **/
  let videoContainers = document.querySelectorAll('.video-container');
  if (videoContainers) {
    videoContainers.forEach(function(videoContainer) {
      let index = videoContainer.getAttribute('data-index');
      videoContainer.addEventListener('click', function () {
        openVideoModal(index);
      });
    });
  }

  function openVideoModal(index) {
    let modal = document.getElementById('videoModal_' + index);
    if (modal) {
      modal.style.display = "block";


      // Ajouter un gestionnaire d'événements clic au bouton de fermeture
      let closeButton = modal.querySelector('.close');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          closeVideoModal(index);
        });
      }
    } else {
      console.error("Modal not found for index: " + index);
    }

    window.addEventListener("click", function (event) {
      if (event.target === modal) {
        closeVideoModal(index);
      }
    });
  }
  function closeVideoModal(index) {
    let modal = document.getElementById('videoModal_' + index);
    if (modal) {
      modal.style.display = "none";
    }
  }


  let btn = document.querySelector("#topbut");
  if (btn) {
    // Fonction callback à exécuter lorsque l'élément de classe "footer" entre dans la vue
    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          btn.classList.add("visible");
        } else {
          btn.classList.remove("visible");
        }
      });
    };

    // Création d'un observer qui observe l'élément de classe "footer"
    const observer = new IntersectionObserver(callback, {
      root: null,
      threshold: 0.1 // Déclencher lorsque 10% de l'élément est visible
    });

    // Observe l'élément de classe "footer"
    const footer = document.querySelector(".footer");
    if (footer) {
      observer.observe(footer);
    }

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      document.querySelector("html, body").scrollTop = 0;
    });
  }


}); // FIN READY



function calculateTimeRemaining(endDate) {
  const end = new Date(endDate).getTime();
  const now = new Date().getTime();

  const timeRemaining = end - now;

  const totalSeconds = Math.floor(timeRemaining / 1000);
  const totalHours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    totalHours,
    minutes,
    seconds,
    timeRemaining
  };
}

function startCountdown() {

  const dateFinale = document.getElementById('date-finale').innerText;
  const countdownElement = document.getElementById('countdown');


  function updateCountdown() {
    const { totalHours, minutes, seconds, timeRemaining } = calculateTimeRemaining(dateFinale);

    if (timeRemaining >= 0) {
      countdownElement.innerHTML = `${totalHours}h ${minutes}min ${seconds}sec`;
    } else {
      countdownElement.innerHTML = '';
    }
  }

  if (dateFinale){
    // Mettre à jour le décompte toutes les secondes
    setInterval(updateCountdown, 1000);
    // Mettre à jour immédiatement sans attendre la première seconde
    updateCountdown();
  }
}